import { IMAGES } from "utils/images";
import { Container, InOfFlow, ShadowBackground, WrapperContainer } from "./Styled";
import { clsx } from "clsx";

interface Props {
	content: any;
	onClickExit: any;
	className?: string;
}

const CommonModal = (props: Props) => {
	const { content, onClickExit, className } = props;
	return (
		<ShadowBackground>
			<WrapperContainer className={clsx("relative flex h-full justify-center", className)}>
				<Container>
					<div className="flex cursor-pointer justify-end">
						<img
							alt=""
							id="close"
							src={IMAGES.icon.close}
							width="16px"
							height="16px"
							onClick={onClickExit}
						/>
					</div>
					<div className="flex justify-center">{content}</div>
				</Container>
			</WrapperContainer>
			<InOfFlow></InOfFlow>
		</ShadowBackground>
	);
};

export default CommonModal;
